export var weekdays = ["D", "S", "T", "Q", "Q", "S", "S"];
export var months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
];
export var periods = ["day", "week", "month", "year"];
export var hours = Array.from(Array(24).keys());
// create minutes array from 0 to 59
export var minutes = Array.from(Array(60).keys());
//# sourceMappingURL=constants.js.map